<template lang="pug">
  v-dialog(v-model="dialog" persistent max-width="350")
    v-card(style="border-radius: 12px; padding: 32px 24px;")
      v-card-text.text-center(style="padding: 0;")
        .d-flex.justify-center.mb-4
          div(style="width: 120px; height: 120px; display: flex; align-items: center; justify-content: center; overflow: hidden;")
            img(
              src="@/assets/characters/informa.svg"
              alt="Información"
              style="width: 100%; height: 100%; object-fit: contain;"
            )
        h2.omnesMedium(style="color: #0855C4; font-size: 20px; margin-bottom: 24px; text-align: center;") ¡Importante!
        p(style="color: #64748B; font-family: 'Omnes Regular'; font-size: 14px; line-height: 1.5; margin-bottom: 16px; padding: 0 8px; text-align: center;")
          | Actualmente estamos evaluando tu solicitud de préstamo anterior. Para poder pedir uno nuevo, primero debemos terminar esta revisión.
        p(style="color: #64748B; font-family: 'Omnes Regular'; font-size: 14px; line-height: 1.5; margin-bottom: 32px; padding: 0 8px; text-align: center;")
          | Recuerda que el plazo máximo de respuesta es de 2 días hábiles.
        v-btn.omnesMedium.prestamo-vida-btn-primary(
          block
          dark
          depressed
          style="border-radius: 8px; height: 50px; text-transform: none; font-size: 16px;"
          @click="onEntendido"
        )
          | Entendido
</template>

<script>
export default {
  name: 'PopupSolicitudEnCurso',
  props: {
    openPopup: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.openPopup
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    onEntendido () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.prestamo-vida-btn-primary {
  background: var(--fuchsia-color) !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/prestamos-vida/PopupSolicitudEnCurso.vue